import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Check, Loader2, Plus } from "lucide-react";
import { fetchEdu, setEdu } from "@/lib/bf";
import BFEduEvents from "./BFEduEvents";

const BR = [["medavita", "Medavita"], ["framesi", "Framesi"], ["lalga", "L'Alga"], ["mowan", "Mowan"]];

export default function BFEdu() {
  const [b, setB] = useState("medavita");
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { setRows(null); fetchEdu(b).then(setRows).catch(() => setRows([])); }, [b]);
  const toggle = (r) => setEdu(r.id, b, !r.interested).then((d) => setRows((l) => l.map((x) => (x.id === r.id ? { ...x, interested: d.interested } : x))))
    .catch(() => toast.error("Nu am putut salva"));
  const shown = (rows || []).filter((r) => !r.interested && q.trim() && `${r.salon} ${r.city} ${r.admin_name}`.toLowerCase().includes(q.trim().toLowerCase())).slice(0, 8);
  const mine = (rows || []).filter((r) => r.interested);
  const n = mine.length;
  return (
    <div data-testid="bf-edu">
      <nav className="bfa-sub-nav">{BR.map(([k, l]) => <button key={k} type="button" className={b === k ? "is-on" : ""} onClick={() => setB(k)} data-testid={`bf-edu-tab-${k}`}>{l}</button>)}</nav>
      <p className="st-hint">Evenimente internaționale {BR.find(([k]) => k === b)[1]}. Adaugă clienții interesați, înscrie-i la eveniment și urmărește cât au cumpărat din pachet.</p>
      {!rows ? <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă…</p> : (
        <>
          <div className="bf-smove-tools"><input className="bf-smove-q" value={q} onChange={(e) => setQ(e.target.value)} placeholder={`Adaugă participant: caută în cei ${rows.length} clienți ai tăi`} data-testid="bf-edu-search" /><b data-testid="bf-edu-count">{n} interesați</b></div>
          {q.trim() && (
            <ul className="bf-smove-list bf-edu-add" data-testid="bf-edu-results">
              {shown.map((r) => (
                <li key={r.id}><button type="button" onClick={() => { toggle(r); setQ(""); }} data-testid={`bf-edu-add-${r.id}`}>
                  <i><Plus size={13} /></i><b>{r.salon || "Salon"}</b><small>{[r.admin_name, r.city].filter(Boolean).join(" · ")}</small>
                </button></li>
              ))}
              {!shown.length && <li className="st-hint">Niciun client găsit (sau e deja în listă).</li>}
            </ul>
          )}
          <div className="st-section-title">Clienții mei interesați ({n})</div>
          {!n && <p className="st-hint" data-testid="bf-edu-empty">Nu ai adăugat încă niciun client. Caută-l mai sus și apasă pe el.</p>}
          <ul className="bf-smove-list">
            {mine.map((r) => (
              <li key={r.id}>
                <button type="button" className="is-on" onClick={() => window.confirm(`Scoți ${r.salon} din lista de interesați? Se anulează și înscrierile lui la evenimentele ${BR.find(([k]) => k === b)[1]}.`) && toggle(r)} data-testid={`bf-edu-row-${r.id}`}>
                  <i><Check size={13} /></i><b>{r.salon || "Salon"}</b><small>{[r.admin_name, r.city].filter(Boolean).join(" · ")} · apasă ca să-l scoți</small>
                </button>
                <Link className="bf-edu-card" to={`/client/${r.id}`} data-testid={`bf-edu-card-${r.id}`}>fișă</Link>
              </li>
            ))}
          </ul>
          <BFEduEvents key={mine.length} brand={b} clients={mine} onChange={(id) => setRows((l) => l.map((x) => (x.id === id ? { ...x, interested: true } : x)))} />
        </>
      )}
    </div>
  );
}
